export const AirConditionSystemKeys = {
  driverHvac: 'driver-hvac',
  hvac1: 'hvac-1',
  hvac2: 'hvac-2',
  tmpOutside: 'tmpOutside',
  hvacsInhibition: 'hvacsInhibition',
  closeDumper: 'closeDumper',
  driverHVACTargetTemperature: 'driverHVACTargetTemperature',
  driverHvacAvgInsideTemperature: 'driverHvacAvgInsideTemperature',
  driverHVACMode: 'driverHVACMode',
  driverHvacClosed: 'driverHvacClosed',
  hvac1AndHvac2TargetTemperature: 'hvac1AndHvac2TargetTemperature',
  hvac1AvgInsideTemperature: 'hvac1AvgInsideTemperature',
  hvac2AvgInsideTemperature: 'hvac2AvgInsideTemperature',
  hvac1Mode: 'hvac1Mode',
  hvac2Mode: 'hvac2Mode',
  hvac1Closed: 'hvac1Closed',
  hvac2Closed: 'hvac2Closed',
  driverHvacCommunicationError: 'driverHvacCommunicationError',
  driverHvacMajorError: 'driverHvacMajorError',
  driverHvacMinorError: 'driverHvacMinorError',
  hvac1CommunicationError: 'hvac1CommunicationError',
  hvac2CommunicationError: 'hvac2CommunicationError',
  hvac1MajorError: 'hvac1MajorError',
  hvac2MajorError: 'hvac2MajorError',
  hvac1MinorError: 'hvac1MinorError',
  hvac2MinorError: 'hvac2MinorError'
} as const;
